var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79688 2.84375C4.33748 2.84375 2.34375 4.83748 2.34375 7.29688C2.34375 9.75627 4.33748 11.75 6.79688 11.75C9.25627 11.75 11.25 9.75627 11.25 7.29688C11.25 4.83748 9.25627 2.84375 6.79688 2.84375ZM1.40625 7.29688C1.40625 4.31972 3.81972 1.90625 6.79688 1.90625C9.77403 1.90625 12.1875 4.31972 12.1875 7.29688C12.1875 10.274 9.77403 12.6875 6.79688 12.6875C3.81972 12.6875 1.40625 10.274 1.40625 7.29688Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9454 10.4459C10.1285 10.2628 10.4253 10.2628 10.6083 10.4459L13.456 13.2936C13.6391 13.4766 13.6391 13.7734 13.456 13.9565C13.2729 14.1395 12.9761 14.1395 12.7931 13.9565L9.9454 11.1088C9.76234 10.9257 9.76234 10.6289 9.9454 10.4459Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8261b31e383494c6c3a200264c510880.svg";
export { ForwardRef as ReactComponent };